import React from 'react';
import { Alert, Button, Grid, Snackbar, Tooltip } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useTranslation } from 'react-i18next';
import { usePrefillFromClipboard } from './usePrefillFromClipboard';

export const PrefillButton = () => {
  const { t } = useTranslation();
  const { handlePrefill, snackbar, closeSnackbar } = usePrefillFromClipboard();

  return (
    <>
      <Grid container justifyContent="flex-end" sx={{ mt: 1 }}>
        <Tooltip title={t('externalPrefill.tooltipLabel')}>
          <Button
            variant="text"
            size="small"
            startIcon={<AutoFixHighIcon sx={{ fontSize: 16 }} />}
            onClick={handlePrefill}
            sx={{ color: 'text.secondary', fontWeight: 400, fontSize: 13, minHeight: 32 }}>
            {t('externalPrefill.chipLabel')}
          </Button>
        </Tooltip>
      </Grid>
      <Snackbar
        open={snackbar.open}
        onClose={closeSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};
